import {
  NotificationActionTypes,
  GET_NOTIFICATIONS,
  SET_NOTIFICATIONS,
  Notifications,
  UPDATE_UNREAD_COUNT,
} from './types';

const initialState: Notifications = {
  notification: [],
  isLoading: false,
  unread: 0,
};

export const notificationReducer = (
  state = initialState,
  action: NotificationActionTypes
) => {
  const { type, notification, unread } = action;
  switch (type) {
    case GET_NOTIFICATIONS: {
      return { ...state };
    }
    case SET_NOTIFICATIONS:
      return { ...state, notification, unread };
    case UPDATE_UNREAD_COUNT:
      return { ...state, unread: 0 };
    default:
      return state;
  }
};
